/* form-footer.tsx generated by @compiled/babel-plugin v0.36.0 */
import "./form-footer.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
var formFooterWrapperStyles = null;
var justifyContentStyles = null;

/**
 * __Form footer__
 *
 * A form footer has the content to be shown at the bottom of the form. This is usually the submit button.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
 * - [Usage](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
 */
export default function FormFooter(_ref) {
  var _ref$align = _ref.align,
    align = _ref$align === void 0 ? 'end' : _ref$align,
    children = _ref.children;
  return /*#__PURE__*/React.createElement("footer", {
    className: ax(["_1e0c1txw _1bahesu3 _1pfh1ejb", align === 'start' && "_1bah1y6m"])
  }, children);
}